import { handleActions } from 'redux-actions';
import actions from '../actions/nativeLogging';

const defaultState = { logs: [] };

export default handleActions({
  [actions.append]: ({ logs }, { payload }) =>
    ({
      logs: [...logs, payload],
    }),
}, defaultState);



// WEBPACK FOOTER //
// ./src/state/reducers/nativeLogging.js